export default theme => ({
  showPartNumberRegistries__action: {
    '&:not(:last-child)': {
      marginLeft: theme.spacing.unit * 2
    }
  },

  showPartNumberRegistries__actions: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'flex-start',
    marginTop: theme.spacing.unit * 4
  },

  showPartNumberRegistries__header: {
    marginBottom: theme.spacing.unit * 4
  },

  showPartNumberRegistries__value: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing.unit * 3
    }
  },

  showPartNumberRegistries__wrapper: {
    backgroundColor: 'transparent',
    margin: `${theme.spacing.unit * 5}px auto`,
    maxWidth: 700,
    padding: theme.spacing.unit * 4
  }
})
